module.exports = __webpack_public_path__ + "static/media/walker.649009fe.svg";